export default "__VITE_ASSET__D_C9wZLB__"